if (!customElements.get('and-purchase-options')) {
  customElements.define('and-purchase-options', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const initialize = () => {
        if (!this.isConnected) return;
        const data = this.querySelector('[data-purchase-variants]');
        this.form = this.querySelector('form');
        if (!data || !this.form) return;
        this.variants = JSON.parse(data.textContent);
        const options = { signal: this.controller.signal };
        this.form.addEventListener('variant:change', event => this.render(event.detail.variant), options);
        this.render(this.variants.find(variant => String(variant.id) === this.dataset.variant));
      };
      if (this.querySelector('[data-purchase-variants]')) initialize(); else requestAnimationFrame(initialize);
    }
    disconnectedCallback() { this.controller?.abort(); this.clearShipping(); }
    clearShipping() {
      const info = this.closest('product-info');
      if (!info) return;
      info.querySelectorAll('[data-and-shipping-hidden]').forEach(element => {
        element.hidden = element.dataset.andShippingHidden === 'true';
        delete element.dataset.andShippingHidden;
      });
    }
    render(selected) {
      const mode = this.dataset.mode || 'theme';
      if (mode === 'theme' || !selected) return;
      const variant = this.variants.find(item => String(item.id) === String(selected.id));
      if (!variant) return;
      const available = selected.available !== false && variant.available !== false;
      const pre = mode === 'preorder' || (mode === 'auto' && variant.tracked && Number(variant.quantity) <= 0 && variant.policy === 'continue' && available);
      const label = pre ? this.dataset.preorderLabel : this.dataset.regularLabel;
      this.dataset.state = pre ? 'preorder' : 'regular';
      const buttons = [...document.querySelectorAll('button[name="add"]')].filter(button => button.form === this.form || button.getAttribute('form') === this.form.id);
      buttons.forEach(button => {
        button.dataset.preOrder = String(pre);
        button.dataset.purchaseLabel = label;
        if (!button.disabled && available) {
          const target = button.querySelector('.btn-text span') || button.querySelector('.btn-text');
          if (target) target.textContent = label;
        }
      });
      const property = this.querySelector('[data-order-type]');
      if (property) { property.disabled = !pre || !available; property.value = this.dataset.preorderLabel || 'Pre-order'; }
      const note = this.querySelector('[data-preorder-note]'); if (note) note.hidden = !pre;
      const copy = this.querySelector('[data-preorder-copy]'); if (copy) copy.hidden = !available;
      const blocked = this.querySelector('[data-preorder-blocked]'); if (blocked) blocked.hidden = available;
      this.clearShipping();
      if (pre && this.dataset.hideShipping !== 'false') {
        this.closest('product-info')?.querySelectorAll('.product__shippingtime').forEach(element => {
          element.dataset.andShippingHidden = String(element.hidden); element.hidden = true;
        });
      }
    }
  });
}
